import { AttentionTypes } from '../../Definitions'
import { Pages } from '../../Navigation/root'
import { LangFile } from './'

const Texts:LangFile = {
  // #region | General
  additional: "øvrigt",
  and: "og",
  change: "skift",
  choose: "vælg",
  deleteFailed: "sletning fejlede",
  editFailed: "redigering fejlede",
  filterBy: "filtrer efter",
  from: "fra",
  general: "generelt",
  no: "nej",
  noData: "Ingen data",
  noOptions: "Ingen valgmuligheder",
  of: "af",
  off: "Slukket",
  on: "Tændt",
  optional: "valgfri",
  page: "side",
  reset: "nulstil",
  required: "påkrævet",
  saveAlert: "Venligst gem eller afbryd rettelserne.",
  search: "Søg",
  select: "Vælg",
  success: "Succes",
  to: "til",
  unknown: "ukendt",
  wasUpdated: "blev opdateret",
  wasDeleted: "blev slettet",
  useSelectedTime: "benyt valgt tidspunkt",
  yes: "ja",
  // #endregion

  // Regarding the language list:
  // Please translate only your own language. 
  // If your language is not on the list, then add it using a maximum of two 
  // initials followed by a colon and the language in quotation marks.
  languages: { 
    en: "english",
    dk: "dansk",
    es: "español",
    de: "deutsch",
    ma: "mandarin",
    ko: "한국어",
    nl: "nederlands",
  },
  
  cookie: {
    header: "cookies",
    context1: "Agrisys A/S benytter cookies til følgende formål:",
    context2: "Ved at klikke på “accepter alle” accepterer du vores brug af cookies.",
    purpose1: "For at understøtte websitets funktionalitet, for eksempel ved at huske dine indstillinger for cookies, foretrukne sprog, valutaer osv.",
    purpose2: "For at udføre statistisk analyse af din brug af websitet, for eksempel ved at måle, hvilken type indhold du ser på og klikker på. Ellers vil et minimum af cookies blive brugt, som er nødvendige for, at servicen kan fungere – for eksempel til at håndtere login og hente data fra Consys-platformen.",
    accept: "accepter nødvendige",
    acceptAll: "accepter alle"
  },

  // #region | Units
  units: {
    animal: "dyr",
    animals: "dyr",
    units: "enheder",
    capacity: "kapacitet",
    cup: "kop",
    cups: "kopper",
    date: "dato",
    day: "dag",
    days: "dage",
    g: "g",
    hour: "time",
    hourAgo: "time siden",
    hours: "Timer",
    hoursAgo: "timer siden",
    kg: "KG",
    minutAgo: "minut siden",
    minutesAgo: "minutter siden",
    min: "min",
    milisec: "milisek",
    pct: "PCT",
    sec: "sek",
    time: "gang",
    times: "gange",
    timeToday: "gang idag",
    timesToday: "gange idag",
    total: "total",
    energy: "energi",
    gramPerMinute: "gram per minut",
    lenght: "længde"
  },
  // #endregion

  // #region | Buttons
  buttons: {
    add: "tilføj",
    apply: "anvend",
    cancel: "afbryd",
    commit: "udfør",
    confirm: "bekræft",
    create: "opret",
    csv: "csv",
    deselectAll: "fravælg alle",
    details: "detaljer",
    edit: "ret",
    excel: "excel",
    filter: "filtrer",
    goBack: "gå tilbage",
    menu: "menu",
    move: "flyt",
    next: "næste",
    options: "muligheder",
    prev: "forrige",
    print: "print",
    resetFilters: "nulstil filtre",
    save: "gem",
    selectAll: "vælg alle",
  },
  // #endregion

  // #region | Menu Headers
  menuHeaders: {
    overview: "oversigt",
    globalMenu: "global menu",
    systemMenu: "system menu",
    attentions: "advarsler",
    quickEntry: "hurtig redigering",
    language: "sprog",
    [Pages.dashboard]: "dashboard",
    [Pages.kpi]: "kpi",
    [Pages.feedCurves]: "foderkurver",
    [Pages.feedCurve]: "foderkurve",
    [Pages.components]: 'komponenter',
    [Pages.componentsAlternatives]: "komponent alternativer",
    [Pages.mixtures]: "blandinger",
    [Pages.silos]: "siloer",
    [Pages.silosSettings]: "silo indstillinger",
    [Pages.animals]: "dyr",
    [Pages.animal]: "dyr",
    [Pages.animalsGroups]: "dyregrupper",
    [Pages.reports]: "rapporter",
    [Pages.report]: "rapport",
    [Pages.archive]: 'arkiv',
    [Pages.logbook]: "logbog",
    [Pages.globalSettings]: "indstillinger",
    [Pages.devices]: "enheder",
    [Pages.freeda_lf]: "oversigt",
    [Pages.freeda_lf_sections]: 'lokationer',
    [Pages.freeda_lf_settings]: 'indstillinger',
    [Pages.op_operations]: 'operationer',
    [Pages.op_quickEntry]: 'Hurtig redigering',
    [Pages.freeda_esf]: "oversigt",
    [Pages.freeda_esf_sections]: "lokationer",
    [Pages.freeda_esf_settings]: "indstillinger",
  },
  // #endregion

  // #region | User
  user: {
    userInformation: "bruger information",
    user: "bruger",
    userName: "Brugernavn",
    firstName: "Fornavn",
    lastName: "Efternavn",
    phone: "Telefon",
    email: "Email",
    password: "Kodeord",
    repeatPassword: "Gentag kodeord",
    country: "Land",
    address: "Adresse",
  },
  // #endregion

  // #region | Farm
  farm: {
    farmInformation: "Gård information",
    farmName: "Gård navn",
    city: "By",
    street: "Vej",
    phone: "Telefon",
    vat: "CVR",
    email: "Email"
  },
  // #endregion

  // #region | Milestones
  milestones: {
    general: {
      milestone: "Milepæl",
      milestones: "Milepæle",
      milestoneDay: "Milepæl dag",
      noMilestoneFound: "Ingen milepæl fundet",
      animalsInMilestones: "Dyr i milepæle",
      latestMilestone: "Nuv. milepæl",
      milestoneDayNow: "Nuv. milepælsdag",
      newMilestone: "Ny milepæl"
    },
    defaultMilestones: {
      farrowing: "Faring",
      insemination: "Inseminering",
      weaning: "Fravænning",
      movedToFarrowing: "Flyttet til faring"
    }
  },
  // #endregion

  // #region | Events
  events: { 
    events: "begivenheder", 
    eventName: "navn", 
    eventDate: "dato", 
    eventNote: "note",
    eventTime: "tidspunkt",
    typeMissing: "type mangles",
    dateMissing: "dato mangles",
    noteMissing: "note mangles",
    addEvent: "tilføj begivenhed",
    animal: "dyr", 
  },
  // #endregion

  // #region | Devices
  devices: {
    devices: "enheder",
    name: "navn",
    cpuId: "CPU ID",
    type: "Type",
    connection: "forbindelse",
    system: "system",
    noControllersFound: "ingen lan controllers fundet",
    lanControllers: "lan controllers",
    newLcBoard: "nyt LC board",
    boardName: "board navn",
    boardNameMissing: "board navn mangles", 
    powerSupplyMissing: "power supply mangles", 
    maxAcPortsMissing: "maks ac porte mangles", 
    noIoBoards: "ingen I/O boards fundet",
    ioBoards: "I/O boards",
    newIoBoard: "nyt I/O board",
    layout: "udseende",
    horizontal: "Horisontal",
    vertical: "Vertikal",
    asc: "Stigende",
    desc: "Faldende",
    columns: "kolonner",
    rows: "rækker",
    order: "rækkefølge",
    direction: "retning",
    chooseIo: "Vælg I/O",
    chooseRfidIo: "Vælg RFID læser I/O", 
    remainingInputs: "resterende indgange",
    remainingOutputs: "resterende udgange",
    aicoIo: "I/O Boards",
    output: "Udgang",
    input: "Indgang",
    board: "board",
    moveBoard: "flyt board",
    noTerminals: "Ingen terminaler",
    terminalPort: "Terminal port",
    pen: "Sti",
    ioSpecifications: "I/O specifikationer",
    numbering: "nummerering",
    manual: "manuel",
    automatic: "automatisk",
    pattern: "mønster",
    topLeft: "top venstre",
    topRight: "top højre",
    bottomLeft: "bund venstre",
    bottomRight: "bund højre",
    startCorner: "start hjørne",
    noLanController: "Ingen lan controller",
    noCpuId: "Intet CPU-ID",
    noSystem: "Intet system",
    server: "Server",
  },
  // #endregion

  // #region | System Controls
  systemControls: {
    general: {
      startSystem: "start system",
      systemControls: "system styring",
      emergencyStop: "nødstop",
      stopSystem: "stop system",
      startAll: "start alle",
      startSection: "start sektion",
      startSelected: "start valgte",
      calibrateSection: "kalibrer sektion",
      calibrateSelected: "kalibrer valgte",
      emptySection: "tøm sektion",
      emptySelected: "tøm valgte",
      clickPen: "Klik på de stier du vil vælge",
      clickStation: "Klik på de stationer du vil vælge", 
      unClickPen: "Klik på de stier du vil fravælge",
      orSelectAll: "Eller vælg alle",
      orDeselectAlle: "Eller fravælg alle",
      problem: "problem",
      problems: "problemer",
      warning: "advarsel",
      warnings: "advarsler",
      attention: "advarsel",
      attentions: "advarsler",
      attentionType: "Advarselstype",
      systemState: "Systemtilstand",
      staticFeeding: "Statisk fodring",
      nextFeeding: "Næste fodring",
      resolvedWeight: "Målt fodermængde",
      noPensSelected: "Ingen stier valgt",
      noStationsSelected: "Ingen stationer valgt",
      feeding: "Fodrer",
      feedingFailed: "Fodring fejlede",
      calibrating: "Kalibrerer",
      calibratingFailed: "Kalibrering fejlede",
      changeTime: "Skift varighed",
      emptying: "Tømmer",
      emptyingFor: "Tømmer i",
      emptyingFailed: "Tømning fejlede",
      controls: "Styrer",
      confirmStop: "Vil du lave et nødstop af systemet",
      goToSystem: "gå til system",
      systemStatus: "system status",
      date: "dato",
      level: "level",
      type: "type",
      inspect: "inspicér",
      delete: "slet",
      logid: "log ID",
      system: "System",
      motor: "Motor",
      animal: "Dyr",
      alerts: "alarmer",
      location_name: "Lokationsnavn",
      fk_lan_controllers: "FK Lan Controllers",
      lan_controller_log_id: "Lan Controller Log ID",
      attention_message: "Advarselsbesked",
      attention_time: "Advarselstidspunk",
      runningWith: "kører med",
      technicalData: "teknisk data",
      startLocation: "start lokation", 
      calibrateLocation: "kalibrer lokation",
      gateControl: "låge kontrol",
      autotuneAntenna: "autotune antenne",
      openGate: "åben låge",
      closeGate: "luk låge",
      blockGate: "bloker låge",
      unblockGate: "bloker ikke låge",
      autotuneSelected: "autotune valgte",
      autoTuneFailed: "autotune fejlede"
    },
    states: {
      [AttentionTypes.good]: "Kører",
      [AttentionTypes.neutral]: "Slukket",
      [AttentionTypes.warning]: "Advarsel",
      [AttentionTypes.alert]: "Alarm"
    },
    createSystem: {
      createNewSystem: "opret nyt system",
      systemName: "system navn",
      systemType: "system type",
      systemNameMissing: "system navn mangles",
      systemTypeMissing: "system type mangles",
      systemLimitReached: "maks antal systemer nået",
      createSystem: "opret system"
    },
    blueprint: {
      blueprint: "plantegning",
      upload: "overfør",
      wrongType: "fejl i bearbejdning af fil",
      wrongSize: "filen er for stor (maks 500kB)",
      pleaseDropImage: "venligst vælg en JPEG fil",
      pleaseSelectImage: "venligst vælg en JPEG fil",
      dropImage: "Træk og slip din plantegning her",
      browseImage: "Eller gennemse filer fra din computer",
      chooseFile: "vælg fil",
      chooseAgain: "vælg igen"
    }
  },
  // #endregion
  
  // #region | Motor Specs
  motorSpecs: {
    general: {
      skipCnt: "Antal skip",
      skipTime: "Skip tid",
      powerConsumption: "Strømforbrug",
      calibrationValue: "Kalibreringsværdi",
      rotationTime: "Rotationstid",
      statusMode: "Status tilstand",
      noSkip: "Ingen skip",
      noPowerConsumption: "Ingen strømforbrug",
      noCalibrationValue: "Ingen kalibreringsværdi",
      noRotationTime: "Ingen rotationstid",
      noStatusMode: "Ingen status tilstand",
      pending: "afventer",
      activated: "aktiveret",
      skippedUntil: "Skippet indtil",
      noLiveData: "Ingen live data"
    },
    terminalTypes: {
      input: "Indgang",
      output: "Udgang",
      buttonInput: "Knap udgang",
      gateSensorInput: "Lågesensor indgang",
      digitalInput: "Digital indgang",
      waterOutput: "Vand udgang",
      inputMotor: "Indgang motor",
      cupMotorOutput: "Kop motor udgang",
      cupMotorInput: "Kop motor indgang",
      gateMotorOutput: "Låge motor udgang",
      gateMotorInput: "Låge motor indgang",
      rfidReader: "RFID læser",
      rfidReaderInput: "RFID læser indgang",
      rfidReaderDeviceId: "RFID læser device ID",
      sensorP: "Sensor P",
      defaultMotor: "std. motor",
      locationFeeder: "lf motor",
      activator: "aktivator",
      water: "vand"
    },
    terminalProgrammed: {
      disabled: "Slukket",
      calibration: "Kalibraring",
      feedingOnFeedingTimes: "Fodrer baseret på fodertider",
      motorPassive: "Passiv Motor"
    }
  },
  // #endregion

  // #region | Params
  params: {
    animal: "Dyr",
    animalId: "Dyrenr.",
    animal_number: "Dyrenr.",
    location: "Lokation",
    location_id: "Lokation",
    feedCurve: "Foderkurve",
    feedCurveId: "Foderkurve",
    group: "Gruppe",
    animal_group_id: "Gruppe",
    condition: "Tilstand",
    removeAnimals: "Flyt dyr",
    resetTotalConsumed: "Nulstil total forbrug",
    manualFeedStart: "Manuel fodringsstart",
    clearCalendarEvents: "Tøm kalender begivenheder",
    insemination: "Inseminering",
    weaning: "Fravænning",
    farrowing: "Faring",
    pregnancyCheck: "Drægtighedscheck",
    birthDate: "Fødselsdag",
    pregnant: "Drægtig",
    responderNo: "Respondernr.",
    responderNumber: "Respondernr.",
    lifeNo: "Livsnr.",
    life_number: "Livsnr.",
    animalType: "Dyretype",
    milestone: "Milepæl",
    milestone_id: "Nuværende milepæl",
    milestone_day: "Milepæl dag",
    system: "System",
    system_id: "System",
    excess_remaining: "Mangler mere end",
    animalRemainingToday: "Levnet idag",
    animalRemainingYesterday: "Levnet igår",
    animalConsumedToday: "Spist idag",
    animalConsumedYesterday: "Spist igår",
    animalMilestoneDay: "Nuværende milepælsdag",
    animalCycleDayTotal: "Total cyklus dag",
    section: "Sektion",
    reset_consumption: "Nulstil fodringer",
  },
  negativeParams: {
    animal: "Intet dyr",
    animals: "Ingen dyr",
    animalId: "Intet dyrenr.",
    location: "Ingen lokation",
    feedCurve: "Ingen foderkurve",
    group: "Ingen gruppe",
    condition: "Ingen tilstand",
    component: "Intet komponent",
    birthDate: "Ingen fødselsdag",
    pregnant: "Ikke drægtig",
    responderNo: "Intet respondernr.",
    lifeNo: "Intet livsnr.",
    animalType: "Ingen dyretype",
    milestone: "Ingen milepæl",
    system: "Intet system",
    ds: "Ingen DS",
    energy: "Ingen energi",
    limit: "Ingen grænse",
    gramPerMinute: "Ingen gram per minut",
    priority: "Ingen prioritet",
    protein: "Ingen protein",
  },
  // #endregion

  // #region | Configs
  configs: {
    stationStatus: {
      creation: "Opretter",
      init: "Initialiserer",
      termCheck: "Terminal tjek",
      calibrate: "Kalibrerer",
      idle: "Afventer",
      waitingTag: "Venter på øremærke",
      fetchFeeding: "Henter fodring",
      oneFeeding: "1 fodring",
      spray: "Sprayer",
      feeding: "Fodrer",
      waitingLeave: "Venter på afgang",
      blocked: "Blokeret",
      disabled: "Deaktiveret",
      error: "Fejl",
      end: "Afsluttet"
    },
    feedMotor: {
      init: "Initialiserer",
      idle: "Afventer",
      running: "Kører",
      bookCal: "Kalibrerer",
      bookEmpty: "Tom",
      starting: "Starter",
      cal: "Kalibrerer",
      empty: "Tom",
      end: "Afsluttet",
      retry: "Prøver igen",
      safetyOne: "Sikkerhed 1",
      safetyTwo: "Sikkerhed 2",
      safetyThree: "Sikkerhed 3",
      error: "Fejl"
    },
    gateMotor: {
      unknown: "Ukendt",
      noGate: "Ingen låge",
      gateClosed: "Låge lukket",
      gateClosing: "Låge lukker",
      gateOpen: "Låge åben",
      gateOpening: "Låge åbner"
    }
  },
  // #endregion

  // #region | Feed
  feed: {
    general: {
      feed: "foder",
      feeding: "Fodring",
      remainingToday: "Levnet idag",
      remainingYesterday: "Levnet igår",
      waterUseToday: "Vandforbrug idag",
      notFed: "Fodret <20% seneste to dage",
      feedLastDays: "sidste 10 dage",
      currentProgress: "nuværende udvikling",
      fedLastPeriod: "fodret seneste periode",
      fedTotal: "fodret total",
      feedConsumption: "foderforbrug",
      feedBalance: "foderbalance",
      consumedToday: "spist idag",
      consumedYesterday: "spist igår",
      expectedConsumption: "Forventet forbrug",
      actualConsumption: "Faktisk forbrug"
    },
    feedCurve: {
      feedCurve: "Foderkurve",
      active: "aktiv",
      noFeedCurve: "Ingen foderkurve fundet",
      default: "standard",
      minFeedSpeed: "minimum fodringshastighed (g/min)",
      maxFeedSpeed: "maximum fodringshastighed (g/min)",
      feedSpeed: "fodringshastighed",
    },
    feedCorrection: {
      increased: "forøget",
      decreased: "reduceret",
      disabled: "deaktiveret",
      feedCorrection: "Foder Korrigering",
      feedCorrections: "Foder Korrigeringer",
    },
    feedSkip: {
      feedSkip: "foderskip",
      skipFeeding: "skip fodring",
      noSkip: "ingen foderskip",
      skipForNow: "for nu",
      planSkip: "planlæg",
      planFeedSkip: "planlæg foder skip",
      standardSkip: "standard",
      startFeeding: "start fodring",
      invalidDay: "ugyldig dag",
      invalidTime: "ugyldig tid",
      endDateBeforeStartDate: "slutdatoen er tidligere end startsdatoen",
      endTimeBeforeStartTime: "sluttidspunktet er tidligere end startstidspunktet",
      timeSpan: "tidsrum",
      timeAmount: "tidsmængde",
      startDate: "startsdato",
      endDate: "slutdato",
      startTime: "startstidspunkt",
      endTime: "sluttidspunkt",
      plannedSkip: "planlagt skip"
    }
  },
  // #endregion

  // #region | Login Flow
  loginFlow: {
    def: {
      fullView: "fuld visning",
      focus_view: "fokus visning",
      goToSiteList: "Gå til side listen",
      switchTofocus_view: "Skift til fokus visning",
      switchToFullView: "Skift til fuld visning"
    },
    login: {
      login: "log ind",
      logOut: "Log ud",
      welcomeBack: "velkommen tilbage",
      notRegisteredYet: "Endnu ikke registreret",
      createNewuser: "opret ny bruger",
      forgotPassword: "Glemt kodeord",
      resetPassword: "nulstil kodeord",
      missingUserName: "brugernavn mangles",
      missingPassword: "kodeord mangles",
      couldNotLogin: "kunne ikke logge ind",
      noSitesFound: "ingen sider fundet"
    },
    forgotPassword: {
      text: "Hvis der ikke er tilknyttet en e-mail til brugernavnet, bedes du kontakte supporten for yderligere hjælp.",
      text2: "Luk venligst ikke dette vindue, før nulstillingsprocessen er færdig.",
      noEmail: "Ingen email tilknyttet",
      contactSupport: "kontakt supporten",
      usernameRequired: "brugernavn nødvendig",
      noUsernameFound: "brugernavn eksisterer ikke"
    },
    resetPassword: {
      text: `En midlertidig kode er blevet sendt til din email, venligst indsæt det herunder for at oprette et nyt kodeord.`,
      temporaryCode: "Midlertidig kode",
      newPassword: "Nyt kodeord",
      repeatPassword: "Gentag nyt kodeord",
      createNewPassword: "opret nyt kodeord",
      contactSupport: "kontakt supporten",
      noPasswordRevieved: "Modtog du ikke en midlertidig kode",
      newPasswordFail: "kunne ikke oprette nyt kodeord"
    },
    createUser: {
      newUser: "ny bruger",
      missingUserName: "brugernavn mangles",
      missingPassword: "kodeord mangles",
      missingRepeatPassword: "venligst gentag kodeord",
      passwordMismatch: "kodeordene matcher ikke"
    },
    chooseSite: {
      chooseSite: "vælg side",
      siteName: "sidenavn",
      domain: "domæne",
      id: "ID",
      tools: "tools"
    }
  },
  // #endregion

  // #region | Widgets
  widgets: {
    general: {
      noWidgets: "Der er på nuværende tidspunkt ingen widgets på denne side.",
      widgetOptions: "widget styring",
      manageWidgets: "tilpas",
      name: "Navn",
      type: "Type",
      widgetPriority: "Prioritet",
      createNew: "opret ny",
      copyExisting: "kopiér eksisterende",
    },
    widgetTypes: {
      autoReports: "Auto rapporter",
      autoReportsAndMore: "Auto rapporter m.m.",
      graph: "Graf",
      progress: "Status cirkler",
    },
    graph: {
      noGraphSelected: "Ingen graf valgt",
      graphIncludesStart: "Grafen inkluderer alle dyr",
      graphIncludesEnd: ", der har foderforbrugsdata",
      animalsToInclude: "Inkludér dyr baseret på system",
      last10Days: "Seneste 10 dages foderforbrug",
      last10DaysComponent: "Seneste 10 dages foderforbrug fordelt på komponenter"
    },
    autoReports: {
      autoReports: "Auto rapporter",
      navigatedFromSystem: "Navigeret fra system",
      add: "Tilføj auto rapport",
      addExisting: "tilføj eksisterende"
    }
  },
  // #endregion

  // #region | Penlist
  penList: {
    basicDisclaimer: "Hold musen på en værdi for at se kolonne type",
    editDisclaimer: "Redigér et dyr ved at vælge nye værdier",
    addDisclaimer: "Tilføj et dyr fra dropdown - fortryd ved at klikke på skraldespanden",
    moveDisclaimer: "Flyt et dyr til en ny lokation fra dropdown - flyt dyret fra enhver lokation på skraldespanden",
  },
  // #endregion

  // #region | Feed Curve pages
  feedCurvePages: {
    feedCurves: {
      copyFeedCurve: "kopier foderkurve",
      createFeedCurve: "opret foderkurve",
      createFeedCurveFromScratch: "Opret foderkurve fra bunden",
      feedCurveDetails: "foderkurvedetaljer",
      newFeedCurve: "ny foderkurve",
      feedCurveName: "foderkurve navn",
      fromFeedCurve: "fra foderkurve",
      feedCurveNameMissing: "foderkurve navn mangles",
      goToFeedCurvePage: "gå til foderkurvens side"
    },
    components: {
      components: "komponenter",
      emptyText: "Ingen komponenter fundet",
      name: "Komponent navn",
      readyMixture: "Klar til brug",
      priority: "Prioritet",
      ds: "TS",
      energy: "Energi",
      protein: "Protein",
      gramPerMinute: "Gram per minut",
      limit: "Grænse",
      newComponent: "nyt komponent" //NEW 17-04-2026
    },
    feedCurve: {
      spreading: "spredning",
      spreadings: "Spredninger",
      noSpreading: "Ingen spredning",
      settings: "indstillinger",
      day: "dag",
      watchFeedCurve: "se foderkurve",
      doNotPassFeed: "Overfør ikke foder",
      passFeed: "Overfør foder",
      stimuli: "Stimuli",
      noStimuli: "Ingen stimuli",
      addStimuli: "Tilføj stimuli",
      singleStimuli: "Enkelt stimuli",
      repeatStimuli: "Gentag stimuli",
      feedSpeed: "Feed Speed (g/min)",
      maxAmount: "maksimal periode mængde (kg)",
      remainingFeed: "tilbageværende foder",
      maxFeedToPass: "maksimal antal KG til overførsel",
      max: "maks",
      feeding: "fodring",
      feedings: "fodringer",
      feedStimuli: "foderstimuli",
      minutesApart: "minutter imellem",
      addTime: "tilføj tidspunkt",
      saveChanges: "gem ændringer",
      resetChanges: "nulstil ændringer",
      feedCurveLenght: "Længde",
      feedLimit: "Foder grænse",
      animalCount: "Dyr",
      consumedToday: "Spist idag",
      usage: "aktuel brug",
      unknownMilestoneAndDay: "Ukendt milepæl og dag",
      deleteFeedcurve: "slet foderkurve",
      confirmDelete: "Er du sikker på at du vil slette denne foderkurve",
      noFeedcurves: "Ingen foderkurver fundet"
    }
  },
  // #endregion

  // #region | Animal pages
  animalPages: {
    animals: {
      animals: "dyr",
      emptyText: "Ingen dyr fundet",
      quickEntry: "hurtig redigering",
      newAnimal: "nyt dyr",
      viewChanges: "ændringer",
      action: "handling",
      selectAnimals: "vælg dyr",
      missingAnimalNo: "dyrenr. mangles",
      missingResponderNo: "respondernr. mangles",
      kgFedMore: "KG fodret mere end forventet",
      noAnimalsMatchTheSelection: "Ingen dyr matcher det valgte",
      responderLengt: "respondernr. skal være 15 karakterer",
      lifeNoLengt: "livsnr. må ikke overskride 9 karakterer",
      columns: "Kolonner",
      priority: "Prioritet",
      tablePreferences: "tabel præferencer",
      resetConsumptionDisclaimer: "Note: nulstil fodringer er kun tilgængeligt for ESF",
    },
    animalGroups: {
      group: "gruppe",
      numberOfAnimals: "Antal Dyr",
      createGroup: "opret gruppe",
      newGroup: "ny gruppe",
      groupName: "gruppe navn",
    },
    animal: {
      animal: "dyr",
      basicInfo: "basis info",
      noAnimalSelected: "Intet dyr valgt",
      noAnimalsSelected: "Ingen dyr valgt",
      addAnimal: "tilføj dyr",
      addAnimalToPen: "tilføj dyr til sti",
      pen: "Sti",
      moveAnimal: "flyt dyr",
      moveAnimals: "flyt dyr",
      moveAnimalFromPen: "flyt dyr til sti",
      goToAnimal: "gå til dyrets side",
      totalCycleDay: "total cyklus dag",
      marking: "mærkning",
      noTimeline: "Ingen tidslinje fundet",
      timeline: "tidslinje",
      viewTimeline: "vis tidslinje",
      born: "født",
      timelineShows: "tidslinjen viser paritet",
      parity: "paritet",
      deleteAnimal: "slet dyr",
      deleteConfirm: "Er du sikker på, at du vil slette dette dyr?",
      noAnimalsFound: "Ingen dyr fundet"
    }
  },
  // #endregion

  // #region | Report pages
  reportPages: {
    reports: {
      template: "Skabelon",
      templateName: "Skabelon navn",
      addTemplate: "tilføj skabelon",
      copyTemplate: "kopier skabelon",
      createReport: "opret rapport",
      createNewReport: "Start en ny rapport fra bunden",
      newTemplate: "ny skabelon",
      newReport: "ny rapport",
      dataLevel: "Data level",
      filterParameter: "Filter parameter",
      dataParameter: "data parameter",
      reportName: "rapport navn",
      archiveReport: "arkiver rapport",
      startDate: "startsdato",
      endDate: "slutsdato",
      showInReport: "Vis i rapporten",
      fromTemplate: "fra skabelon",
      noReportFound: "Ingen rapport fundet",
      noDataParameterFound: "intet data parameter fundet",
      unknownCondition: "ukendt tilstand",
      unknownAnimalGroup: "ukendt gruppe",
      noFilterParameterFound: "intet filter parameter fundet",
      saveAsTemplate: "gem som skabelon",
    },
    manageTemplates: {
      templateOptions: "skabelon styring",
      manageTemplates: "tilpas",
      copyExisting: "kopiér eksisterende",
      noTemplates: "Der er på nuværende tidspunkt ingen skabeloner på denne side."
    },
    report: {
      report: "rapport",
      editReport: "ret rapport",
      unArchiveReport: "fjern fra arkiv",
      saveAsTemplate: "gem som skabelon",
      noReports: "Ingen rapporter fundet",
      deleteReport: "slet rapport",
      deleteConfirm: "Er du sikker på, at du vil slette denne rapport?"
    },
    reportColumn: {
      system: "System",
      system_id: "System",
      animal_id: "Dyr",
      location: "Lokation",
      location_id: "Lokation",
      section_id: "Sektion",
      section: "Sektion",
      feedcurve_id: "Foderkurve",
      feedCurveId: "Foderkurve",
      animal_number: "Dyrenr.",
      cycle: "Cyklus",
      correction: "Korrektion",
      feedcurve_milestones: "Foderkurve milepæl",
      milestone_day: "Milepælsdag",
      condition: "Tilstand",
      animal_type: "Dyretype",
      responder_number: "Respondernr.",
      life_number: "Livsnr.",
      birthday: "Fødselsdag",
      animal_group_name: "Gruppe",
      milestone_name: "Milepæl",
      milestone_id: "Milepæl",
      animal_group_id: "Gruppe",
      group_id: "Gruppe",
      group_name: "Gruppe",
      system_id_for_report: "System ID for rapport",
      system_name: "System",
      totalPeriodConsumption: "Total periode forbrug",
      consumed: "Forbrug"
    },
    archive: {
      archive: "arkiv",
      filterByNumber: "rapport nummer",
      filterByName: "rapport navn alfabetisk",
      archivedReport: "Arkiveret rapport",
      noStartDateFound: "Ingen startsdato fundet",
      noEndDateFound: "Ingen slutsdato fundet",
    },
    errorMessages: {
      missingName: "navn mangles",
      missingStartDate: "startsdato mangles",
      missingEndDate: "slutsdato mangles",
      missingDataLevel: "datalevel mangles",
      missingFilterParameters: "filterparameter mangles",
    }
  },
  // #endregion

  // #region | Logbook pages
  logPages: {
    logbook: {
      problem: "Problem",
      warning: "Advarsel",
      info: "Info",
      debug: "Fejlfind",
      system: "System",
      motor: "Motor",
      animal: "Dyr",
      time: "tidspunkt",
      level: "level",
      type: "type",
      message: "besked",
      location: "lokation",
      controller: "controller",
      allControllers: "alle controllers",
      controllerName: "controller navn",
      deviceName: "device navn",
      lanControllers: "lan controllers",
      getLog: "få log",
      noLogsAvailable: "Ingen logs fundet",
      responder: "responder",
    },
  },
  // #endregion

  // #region | Global Settings pages
  globalSettingsPages: {
    globalSettings: {
      imperial: "Imperial",
      metric: "Metrisk",
      saveChanges: "gem ændringer",
      discardChanges: "kasser ændringer",
      userManagement: "bruger administration",
      workerManagement: "medarbejder administration",
      timeZone: "tidszone",
      feedDayStart: "foderdagsstart",
      remove: "fjern",
      emailAttentionDisclaimerWorker: "Vælg hvilke systemer, din medarbejder skal modtage advarsler for",
      emailAttentionDisclaimerUser: "Vælg hvilke systemer, du vil modtage advarsler for",
      settingsFor: "indstillinger for",
      systemNotifications: "system notifikationer"
    }
  },
  // #endregion

  // #region | Location Feeder Pages
  locationFeederPages: {
    locationFeeder: {
      sections: "sektioner",
      pens: "stier",
      animals: "dyr",
      sectionNo: "Sektionsnr.",
      pen: "Sti",
    },
    sections: {
      section: "Sektion",
      sections: "sektioner",
      map: "kort",
      animalAmount: "antal dyr",
      penValueHeaders: "hold musen på en værdi for at se kolonne type",
      sectionNotFound: "sektion ikke fundet ",
      emptyPen: "Tom sti",
      feeder: "foderautomat",
      inThisPen: "i denne sti",
      activations: "aktiveringer",
      lastActivated: "sidst aktiveret",
      newSection: "ny sektion",
      sectionName: "sektionsnavn",
      firstPenNo: "første sti nr.",
      penAmount: "antal stier",
      clickOnPen: "Klik på en sti for at tilføje eller fjerne den igen",
      penContent: "sti indhold",
      feederOnly: "Kun foderautomat",
      water: "Vand",
      activator: "Aktivator",
      feederOutput: "Foderautomat udgang",
      waterOutput: "Vand udgang",
      activatorInput: "Aktivator indgang",
      since: "siden",
      redirect: "Dette vil viderestille dig til dyresiden.",
      expand: "udvid",
      collapse: "skjul",
      noSections: "Ingen sektioner fundet",
      noAnimal: "Intet dyr",
      editSection: "rediger section", 
      clickPen: "Klik på de stier du vil redigere", 
      clicStation: "Klik på de stationer du vil redigere",
      deleteSectionConfirm: "Er du sikker på, at du vil slette denne sektion",
      priority: "Prioritet",
      sectionNameMissing: "sektionsnavn mangles", 
      pen: "Sti",
    },
    settings: {
      dailyRotation: "daglig rotation", 
      dailyRotationDisclaimer: "NB: Hvis lokationen er tom eller dyret ingen foderkurve har, vil motoren køre en rotation dagligt af servicehensyn.",
      feedInSilos: "foder i siloer",
      attentionLimit: "advarselsgrænse",
      feedAmount: "fodermængde",
      defFeedAmount: "standard fodermængde (g)",
      deleteSystem: "slet system",
      deleteDisclaimer: "Er du sikker på, at du vil slette dette system",
      systemName: "system navn",
    }
  },
  // #endregion

  // #region | ESF Walk Through Pages
  esfWalkThroughPages: {
    esfWalkThrough: {
      pens: "stier",
      station: "Station",
      stations: "stationer",
      animals: "dyr",
      motor: "motor",
      component: "komponent",
      noComponent: "intet komponent",
      include: "inkludér",
    },
    sections: {
      pen: "sti",
      pens: "stier",
      station: "Station",
      stationFeeding: "fodring",
      feedMotor: "foder motor",
      feedSensor: "foder sensor",
      gateMotor: "låge motor",
      gateSensor: "låge sensor",
      inThisStation: "i denne station",
      previously: "tidligere",
      feedComponents: "foder komponenter",
      stationLastDays: "sidste 10 dage",
      stationLog: "log",
      noPens: "Ingen stier fundet",
      currentlyInThisPen: "i øjeblikket i denne sti",
      animal: "Dyr",
      noAnimal: "Intet dyr",
      unknownAnimal: "Ukendt dyr",
      fedToday: "fodret idag",
      usesToday: "brug idag",
      stationsState: "stationstilstand",
      available: "til rådighed",
      consumed: "udfodret",
      number: "nr",
      water: "vand",
      waterAddedPrCup: "vand tilsat pr. kop",
      waterDelay: "vandforsinkelse",
      gateAdjustment: "justering af låge",
      delayTimeClosingGate: "forsinkelse ved lukning af låge",
      indetificationValidTime: "gyldighedstid for identifikation",
      entryTime: "indgangstid",
      feedMotors: "fodermotorer",
      noFeedBlockTime: "ingen foderblokeringstid",
      lastFeedBlockTime: "sidste foderblokeringstid",
      motorComponents: "motorkomponenter",
      motor: "motor",
      missing: "mangler",
    },
    newSection: {
      firstStationNo: "første stationsnr.",
      firstColumnExit: "første kolonne udgang", 
      secondColumnExit: "anden kolonne udgang", 
      numberOfFeeders: "Antal foderautomater", 
      water: "Vand",
      button: "Knap", 
      waterOutput: "Vand output",
      buttonInput: "Knap indgang", 
      feederOutput: "Foderautomat udgang",
      feederInput: "Foderautomat indgang",
      gateMotorOutput: "Låge motor udgang", 
      gateMotorInput: "Låge motor indgang", 
      gateSensor: "Låge sensor",
      newPen: "ny sti", 
      penName: "sti navn",
      numberOfStations: "antal stationer", 
      clickOnStation: "Klik på en station for at tilføje eller fjerne den igen.", 
      stationContent: "station indhold", 
      editPen: "ret sti", 
      clickStationToEdit: "Klik på de stationer du vil redigere",
      station: "station", 
      penNameMissing: "sti navn mangles", 
      editFailed: "edit failed",
      noStationsSelected: "ingen stationer valgt", 
      deletePenConfirm: "Er du sikker på, at du vil slette denne sti", 
    },
    settings: {
    },

  },
  // #endregion
  
  // #region | Focus View Pages
  focus_viewPages: {
    location: "lokation",
    system: "system",
    section: "sektion",
    inThisPen: "i denne sti",
    today: "i dag",
    pen: "Sti",
    since: "siden",
    day: "Dag",
    moveAnimal: "flyt dyr",
    newLocation: "ny lokation",
    emptyPen: "Tom sti",
  }
  // #endregion
}
export default Texts